import { DELIVERY } from "../actions/actionsTypes";
import { IGlobal } from "../models/global.interface";
import { IActionBase } from "../models/root.interface";

const initialState = {
  deliveryList: null,
  billingDetails: null,
  deliverDEtails: null,
  viewDelivery: null,
  deleteReturnRequestDetails: null,
  getReturnOrderDetails: null,
  viewReturnOrderAPIDetails: null,
  successRequest: null,
  getReturnSalesReason: null,
  getDownloadInvoice: null,
  returnOrder: null,
  viewReturnOrderFormAPI: null
};

function deliveryReducer(state: any = initialState, action: IActionBase): IGlobal {
  switch (action.type) {
    case DELIVERY.GET_DELIVERY_LIST_FETCHING:
      return {
        ...state,
        deliveryList: { loading: true, data: null, err: null }
      };
    case DELIVERY.GET_DELIVERY_LIST_SUCCESS:
      return {
        ...state,
        deliveryList: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.GET_DELIVERY_LIST_ERROR:
      return {
        ...state,
        deliveryList: { loading: false, data: null, err: action.payload.error }
      };

    case DELIVERY.GET_RETURN_DELIVERY_DETAILS_FETCHING:
      return {
        ...state,
        billingDetails: { loading: true, data: null, err: null }
      };
    case DELIVERY.GET_RETURN_DELIVERY_DETAILS_SUCCESS:
      return {
        ...state,
        billingDetails: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.GET_RETURN_DELIVERY_DETAILS_ERROR:
      return {
        ...state,
        billingDetails: { loading: false, data: null, err: action.payload.error }
      };

    case DELIVERY.VIEW_RETURN_ORDER_FETCHING:
      return {
        ...state,
        viewReturnOrderAPIDetails: { loading: true, data: null, err: null }
      };
    case DELIVERY.VIEW_RETURN_ORDER_SUCCESS:
      return {
        ...state,
        viewReturnOrderAPIDetails: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.VIEW_RETURN_ORDER_ERROR:
      return {
        ...state,
        viewReturnOrderAPIDetails: { loading: false, data: null, err: action.payload.error }
      };

    case DELIVERY.VIEW_RETURN_ORDER_FORM_FETCHING:
      return {
        ...state,
        viewReturnOrderFormAPI: { loading: true, data: null, err: null }
      };
    case DELIVERY.VIEW_RETURN_ORDER_FORM_SUCCESS:
      return {
        ...state,
        viewReturnOrderFormAPI: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.VIEW_RETURN_ORDER_FORM_ERROR:
      return {
        ...state,
        viewReturnOrderFormAPI: { loading: false, data: null, err: action.payload.error }
      };

    case DELIVERY.GET_RETURN_ORDER_FETCHING:
      return {
        ...state,
        returnOrder: { loading: true, data: null, err: null }
      };
    case DELIVERY.GET_RETURN_ORDER_SUCCESS:
      return {
        ...state,
        returnOrder: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.GET_RETURN_ORDER__ERROR:
      return {
        ...state,
        returnOrder: { loading: false, data: null, err: action.payload.error }
      };

    case DELIVERY.GET_BILLING_DETAILS_FETCHING:
      return {
        ...state,
        billingDetails: { loading: true, data: null, err: null }
      };
    case DELIVERY.GET_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        billingDetails: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.GET_BILLING_DETAILS_ERROR:
      return {
        ...state,
        billingDetails: { loading: false, data: null, err: action.payload.error }
      };
    case DELIVERY.GET_DELIVERY_DETAILS_FETCHING:
      return {
        ...state,
        deliveryDetails: { loading: true, data: null, err: null }
      };
    case DELIVERY.GET_DELIVERY_DETAILS_SUCCESS:
      return {
        ...state,
        deliveryDetails: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.GET_DELIVERY_DETAILS_ERROR:
      return {
        ...state,
        deliveryDetails: { loading: false, data: null, err: action.payload.error }
      };
    case DELIVERY.CANCEL_RETURN_REQUEST_FETCHING:
      return {
        ...state,
        billingDetails: { loading: true, data: null, err: null }
      };
    case DELIVERY.CANCEL_RETURN_REQUEST_SUCCESS:
      return {
        ...state,
        billingDetails: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.CANCEL_RETURN_REQUEST_ERROR:
      return {
        ...state,
        successRequest: { loading: false, data: null, err: action.payload.error }
      };
    case DELIVERY.GET_RETURN_SALES_REASON_FETCHING:
      return {
        ...state,
        getReturnSalesReason: { loading: true, data: null, err: null }
      };
    case DELIVERY.GET_RETURN_SALES_REASON_SUCCESS:
      return {
        ...state,
        getReturnSalesReason: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.GET_RETURN_SALES_REASON_ERROR:
      return {
        ...state,
        getReturnSalesReason: { loading: false, data: null, err: action.payload.error }
      };
    case DELIVERY.GET_DOWNLOAD_INVOICE_FETCHING:
      return {
        ...state,
        getDownloadInvoice: { loading: true, data: null, err: null }
      };
    case DELIVERY.GET_DOWNLOAD_INVOICE_SUCCESS:
      return {
        ...state,
        getDownloadInvoice: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.GET_DOWNLOAD_INVOICE_ERROR:
      return {
        ...state,
        getDownloadInvoice: { loading: false, data: null, err: action.payload.error }
      };
    case DELIVERY.RAISE_RETURN_REQUEST_FETCHING:
      return {
        ...state,
        successRequest: { loading: true, data: null, err: null }
      };
    case DELIVERY.RAISE_RETURN_REQUEST_SUCCESS:
      return {
        ...state,
        successRequest: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case DELIVERY.RAISE_RETURN_REQUEST_ERROR:
      return {
        ...state,
        billingDetails: { loading: false, data: null, err: action.payload.error }
      };
    case DELIVERY.VIEW_DEILVERY_SUCCESS:
      return {
        ...state,
        viewDelivery: { loading: true, data: action.payload.data, err: null }
      }
    case DELIVERY.VIEW_DELIVERY_ERROR:
      return {
        ...state,
        viewDelivery: { loading: false, data: null, err: { error: "unable to fetch data" } }
      };
    case DELIVERY.VIEW_DEILVERY_SELECTED_SUCCESS:
      return {
        ...state,
        viewDeliverySelected: { loading: true, data: action.payload.data, err: null }
      }
    case DELIVERY.VIEW_DELIVERY_SELECTED_ERROR:
      return {
        ...state,
        viewDeliverySelected: { loading: false, data: null, err: { error: "unable to fetch data" } }
      }
    case DELIVERY.DOWNLOAD_DELIVERY_FETCHING:
      return {
        ...state,
        downloadInvoice: { loading: true, data: null, err: null }
      }
    case DELIVERY.DOWLOAD_DELIVERY_SUCCES:
      return {
        ...state,
        downloadInvoice: { loading: true, data: action.payload.data, err: null }
      }
    case DELIVERY.DOWNLOAD_DELIVERY_ERROR:
      return {
        ...state,
        dowloadInvoice: { loading: true, data: null, err: { error: "unable to fetch data" } }
      }
    default:
      return state;
  }
};

export default deliveryReducer;